import gql from 'graphql-tag'

export default gql`{
  dashboard_widgets: user_accessible_dashboard_widgets{
    id
    name
    description
    settings
  }
}`